import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/cta-epargne-hajj.webp")